<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-y
  >
    <template v-slot:activator="{ on }">
      <v-btn large icon dark v-on="on">
        <v-icon size="30" :color="connectionColor">mdi-palette</v-icon>
      </v-btn>
    </template>
    <v-card>
      <!-- removed for now -->
      <v-list-item>
        <v-list-item-content
          ><v-list-item-title class="font-weight-bold">
            {{ $t("theme-picker.DarkMode") }}</v-list-item-title
          >
        </v-list-item-content>
        <v-list-item-action>
          <v-switch @click="themeMode" v-model="$vuetify.theme.dark" />
        </v-list-item-action>
      </v-list-item>

      <v-divider />
      <v-card-text v-if="tab">
        <v-card
          class="my-2"
          @click="setTheme(theme)"
          hover
          outlined
          v-for="(theme, index) in themes"
          :key="index"
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ theme.name }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action>
              <v-avatar
                color="success"
                size="30"
                v-if="tab.themeName === theme.name"
              >
                <v-icon>mdi-check</v-icon>
              </v-avatar>
            </v-list-item-action>
          </v-list-item>

          <div class="my-2">
            <span v-for="(key, index) in Object.keys(theme.light)" :key="index">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    class="mx-1"
                    label
                    :color="theme.light[key]"
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-chip>
                </template>
                <span>{{ key }}</span>
              </v-tooltip>
            </span>
          </div>
        </v-card>
      </v-card-text>
      <v-card-text v-if="!tab">
        <v-card
          class="my-2"
          :disabled="$vuetify.theme.themes.name === theme.name"
          @click="setTheme(theme)"
          hover
          outlined
          v-for="(theme, index) in themes"
          :key="index"
        >
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ theme.name }}</v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action>
              <v-avatar
                color="success"
                size="30"
                v-if="$vuetify.theme.themes.name === theme.name"
              >
                <v-icon>mdi-check</v-icon>
              </v-avatar>
            </v-list-item-action>
          </v-list-item>

          <div class="my-2">
            <span v-for="(key, index) in Object.keys(theme.light)" :key="index">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                    class="mx-1"
                    label
                    :color="theme.light[key]"
                    v-bind="attrs"
                    v-on="on"
                  >
                  </v-chip>
                </template>
                <span>{{ key }}</span>
              </v-tooltip>
            </span>
          </div>
        </v-card>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn text @click="menu = false" color="grey">{{
          $t("common.close")
        }}</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<!-- code from https://github.com/eyuelberga/vuetify-dynamic-theme/tree/master/src -->

<script>
import ThemeFactoryClass from "@/services/themefactory";

export default {
  name: "ThemeChanger",
  data: () => ({
    menu: false,
    themes: new ThemeFactoryClass().themes,
    connectionColor: "#f1e111",
  }),
  props: {
    useAmplify: {
      type: Boolean,
      default: false,
    },
    tab: {
      type: Object,
    },
  },
  computed: {
    connectionTab: {
      get() {
        return this.tab;
      },
      set(v) {
        this.$emit("connectionTab", v);
      },
    },
  },
  methods: {
    themeMode() {
      console.log("aaa---", this.$vuetify.theme.dark);
      window.vueAppInstance.$localStorage.set(
        "darkmode",
        JSON.stringify(this.$vuetify.theme.dark)
      );
    },
    setTheme(theme) {
      console.log("tab-theme");
      // close menu
      this.menu = false;
      const name = theme.name;
      const dark = theme.dark;
      const light = theme.light;
      this.connectionColor = light.primary;
      if (this.useAmplify) {
        this.$emit("setThemeName", name);
      } else {
        if (this.tab) {
          console.log(
            "tab-theme1",
            this.tab,
            this.connectionColor,
            this.tab.light.primary.toString(),
            theme.light.primary
          );

          let datastr = JSON.parse(
            window.vueAppInstance.$localStorage.get("_cap_connections")
          );
          for (var i = 0; i < datastr.length; i++) {
            if (datastr[i].tabName == this.tab.tabName) {
              datastr[i].themeName = name;
            }
          }
          this.connectionTab.themeName = name;
          window.vueAppInstance.$localStorage.set(
            "_cap_connections",
            JSON.stringify(datastr)
          );
        } else {
          console.log("tab-theme2", this.tab);
          // set themes
          Object.keys(dark).forEach((i) => {
            this.$vuetify.theme.themes.dark[i] = dark[i];
          });
          Object.keys(light).forEach((i) => {
            this.$vuetify.theme.themes.light[i] = light[i];
          });
          // also save theme name to disable selection
          this.$vuetify.theme.themes.name = name;
          window.vueAppInstance.$localStorage.set("apptheme", name);
        }
      }
    },
  },
  created() {
    let themes = new ThemeFactoryClass().themes;
    if (!this.tab) {
      if (window.vueAppInstance.$localStorage.get("apptheme") != null) {
        let apptheme = window.vueAppInstance.$localStorage.get("apptheme");
        this.$applog("startup theme set:" + this.$vuetify.theme.themes.name);
        //get the theme
        for (var jj = 0; jj < themes.length; jj++) {
          let themeObj = themes[jj];
          if (themeObj.name == apptheme) {
            this.connectionColor = themeObj.light.primary;
          }
        }
      }
    } else {
      for (var ii = 0; ii < themes.length; ii++) {
        let tabTheme = themes[ii];
        if (tabTheme.name == this.tab.themeName) {
          this.connectionColor = tabTheme.light.primary;
        }
      }
    }
  },
};
</script>
<style scoped></style>
